import { useEffect, useState } from "react";
import { callHttpClientMethod } from "../../../services/callHttpClient";
import { category, listSize, special } from "../../../services/apiList";
import { BASE_URL, HttpMethod } from "../../../services/api.constant";
import { Category, Product, Size } from "../../../gobalType";
import { normalizePlantApiResponse } from "../../../utils/normalizePlantApiResponse";

type ExplorerCatalogState = {
  loading: boolean;
  categories: Category[];
  sizes: Size[];
  specials: Product[];
};

const initial: ExplorerCatalogState = {
  loading: true,
  categories: [],
  sizes: [],
  specials: [],
};

export function useExplorerCatalog(
  enabled: boolean,
  accessToken: string | undefined
): ExplorerCatalogState {
  const [state, setState] = useState<ExplorerCatalogState>(initial);

  useEffect(() => {
    if (!enabled) {
      setState({ ...initial, loading: false });
      return;
    }

    let cancelled = false;

    const load = async () => {
      setState((s) => ({ ...s, loading: true }));
      try {
        const [catsRes, sizesRes, specialRes] = await Promise.all([
          callHttpClientMethod(BASE_URL + category(), HttpMethod.Get, {}, {}),
          callHttpClientMethod(BASE_URL + listSize(), HttpMethod.Get, {}, {}),
          callHttpClientMethod(
            BASE_URL + special(),
            HttpMethod.Get,
            {},
            {
              headers: {
                Authorization: `Bearer ${accessToken ?? ""}`,
              },
            }
          ),
        ]);
        if (cancelled) return;
        setState({
          loading: false,
          categories: Array.isArray(catsRes?.data) ? catsRes.data : [],
          sizes: Array.isArray(sizesRes?.data) ? sizesRes.data : [],
          specials: normalizePlantApiResponse(specialRes),
        });
      } catch {
        if (!cancelled) {
          setState((s) => ({ ...s, loading: false }));
        }
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [enabled, accessToken]);

  return state;
}
